// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"170":"371844641eb18717","778":"83b6d182ac9300f7"}[chunkId] + ".js";
};